import React, { useRef } from "react";

import RichText from "@cayuse/shared-react.components.form.inputs.rich-text";

import { useRichTextAccessibility } from "hooks/accessibility";

import { QuestionFooter } from "./Question";
import styles from "./styles.css";

const merge = (prev, newProps) => {
	const next = { ...prev, ...newProps };
	if (prev?.i18n) {
		delete next.i18n;
	}

	return next;
};

function InformationTextComponent ({ completeFormModel, config, onChange, onDelete }) {
	const richTextRef = useRef(null);

	useRichTextAccessibility(richTextRef);

	const onChangeConfig = newProps => onChange(prev => merge(prev, newProps));

	return (
		<>
			<div className={`${styles.toolbar} ${styles.marginBottom}`}>
				<div className="ui input form" style={{ flexGrow: 40 }} ref={richTextRef}>
					<label>Information Text</label>
					<RichText maxLength="750"
						onChange={({ value }) => onChangeConfig({ value })}
						value={config.value || ""}
					/>
				</div>
			</div>
			<QuestionFooter
				completeFormModel={completeFormModel}
				config={config}
				onChangeConfig={onChangeConfig}
				onDelete={onDelete}
				hideRequired={true}
				hideComponentSelector={true}
				hideLabel={true}
			/>
		</>
	);
}

InformationTextComponent.showInPalette = () => true;

InformationTextComponent.paletteInformation = () => ({
	id: "informationText",
	name: "Information Text",
	type: "htmlComponent",
	group: "formElement",
});

InformationTextComponent.newElement = () => ({
	designInfo: {
		stencilSuperIds: [
			"Component",
		],
		stencilId: "htmlComponent",
		customStencilId: "null",
	},
	type: "htmlComponent",
});

InformationTextComponent.initialValue = "";


export default InformationTextComponent;
